<app-company-reservation-flow-v2 #reservationFlow [isCreatingTwoPhase]="true"></app-company-reservation-flow-v2>
